const LazyLoad = require('react-lazyload').default;

export default props => <LazyLoad scrollContainer={props.scrollContainer}>{props.children}</LazyLoad>;